var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    stroke: "#2C2D2E",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.5a1 1 0 012 0v2.739l1.201.841a1 1 0 01-1.147 1.639L7.42 9.574a1 1 0 01-.414-.976A1.01 1.01 0 017 8.5v-3z",
    fill: "#2C2D2E"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iNyIgc3Ryb2tlPSIjMkMyRDJFIiBzdHJva2Utd2lkdGg9IjIiLz48cGF0aCBkPSJNNyA1LjVhMSAxIDAgMCAxIDIgMHYyLjczOWwxLjIwMS44NDFhMSAxIDAgMCAxLTEuMTQ3IDEuNjM5TDcuNDIgOS41NzRhMSAxIDAgMCAxLS40MTQtLjk3NkExLjAxIDEuMDEgMCAwIDEgNyA4LjV2LTN6IiBmaWxsPSIjMkMyRDJFIi8+PC9zdmc+Cg==";
export { SvgHistory as ReactComponent };